import { Component, h, JSX, Host, Listen, State } from '@stencil/core';

@Component({
  tag: 'app-modal-scanning-process',
  shadow: false,
})
export class AppModalScanningProcess {
  @State() imageData: string;
  @State() private isVisible = false;
  @State() private loaded = false;

  @Listen('belimoOcrParsingStart', {target: 'document'})
  public belimoOcrParsingStart({detail}: { detail: string }): void {
    this.isVisible = true;
    this.loaded = false;
    this.imageData = '';
    setTimeout(() => this.imageData = detail, 0);
  }

  @Listen('belimoOcrParsingEnd', {target: 'document'})
  public belimoOcrParsingEnd(): void {
    this.isVisible = false;
    this.imageData = undefined;
  }

  public render(): JSX.Element {
    return (
      <Host>
        <div class="modal-scanner__overlay" style={this.isVisible ? { opacity: '1' } : { display: 'none' }}>
          <div class="modal-scanner">
            <div class="modal-scanner__image-container"
                 style={this.loaded ? null : { minHeight: '200px', minWidth: '200px' }}
            >
              <img class="modal-scanner__image" src={this.imageData}
                   onLoad={() => this.loaded = true} alt="Loading"
              />
              <div class="modal-scanner__loader" style={this.loaded ? { display: 'none' } : null} />
            </div>
          </div>
        </div>
      </Host>
    )
  }
}
